import React from 'react';
import PropTypes from 'prop-types';
import { useProductsCartSummary } from 'hooks/store/productsCart/useProductsCartSummary';
import SnacksSummary from 'ui/atoms/SnacksSummary';

/**
 * SnacksSummaryContainer component.
 * Container that connects SnacksSummary with Redux state via custom hook for a specific passenger.
 * Provides total quantity and price from selected products.
 * When isRoundTrip is true, shows combined totals from both segments.
 *
 * @param {object} props - Component props
 * @param {number} props.passengerIndex - Index of the passenger
 * @param {boolean} props.isRoundTrip - Indicates if the trip is round trip
 * @param {function} props.onViewDetails - Callback when "Ver detalles" is clicked.
 * @returns {React.ReactNode} SnacksSummary component with cart data.
 */
const SnacksSummaryContainer = ({ passengerIndex, isRoundTrip = false, onViewDetails }) => {
  // Show combined totals for round trip, or specific segment totals for one-way
  const summarySegment = isRoundTrip ? 'both' : 'outgoing';
  const { totalQuantity, totalPrice } = useProductsCartSummary(passengerIndex, summarySegment);

  return (
    <SnacksSummary price={totalPrice} itemCount={totalQuantity} onViewDetails={onViewDetails} />
  );
};

SnacksSummaryContainer.propTypes = {
  passengerIndex: PropTypes.number.isRequired,
  isRoundTrip: PropTypes.bool,
  onViewDetails: PropTypes.func.isRequired,
};

export default SnacksSummaryContainer;
